import set from "@rill/set";
import rill from "rill";

import addEditController from "./add-edit-tasks-controller.js";
import completeController from "./complete-task-controller.js";
import controller from "./tasks-controller.js";

const Tasks = (app) => {
  app.at(
    "/tasks/*",
    rill()
      .use(set("heading", ["Coaching", "Task List"]))
      .setup((app) => {
        app.get("/", controller);
        app.post("/add-edit", addEditController);
        app.post("/complete", completeController);
      })
  );
};

export default Tasks;
